
// --- Vue & Template imports ---
import { Component, Prop, Vue, Watch} from 'vue-property-decorator';

// Models
import { MenuItem } from '@/models/Menu.model';

@Component
export default class ScreenTakeover extends Vue {
  // Variant allows center and sidebar variants of a Screen Takeover
  // options:
  //    center ** default
  //    sidebar-right
  //    sidebar-left
  @Prop(String) readonly variant!: string;

  // Width of the container on desktop
  // options: any percentage value - eg. 33.333% or 50% or 75%
  @Prop(String) readonly containerWidth?: string;

  // Background Path contains path to fixed background used here
  @Prop(String) readonly backgroundPath!: string;

  // Header style to use
  // options:
  //    [ no value ] // disables
  //    banner (inside content area in a banner block similar to scrubbill)
  //    rows (inside content area)
  //    fixed (sit outside content on sidebar, above content on center)
  @Prop(String) readonly headerStyle!: string;
    // If header Style is configured as banner, you can pass through a class for padding e.g. py-4
    @Prop(String) readonly bannerPadding!: string;
    // Logo Path contains path to logo to display
    @Prop(String) readonly logoPath!: string;
    // Title contains string to display, support basic html via v-html
    @Prop(String) readonly title!: string;
    // Title Color changes text color
    // supports vuetify string & # hex values e.g. white or #fff or #ffffff
    @Prop(String) readonly titleColor!: string;
    // Header Color changes background of banner mode
    // supports vuetify string & # hex values e.g. white or #fff or #ffffff
    @Prop(String) readonly headerColor!: string;

  // Copyright Text contains string for copyright text, support basic html via v-html
  @Prop(String) readonly copyrightText!: string;
    // Copyright Color changes color of copyright text in desktop breakpoint
      // supports vuetify string & # hex values e.g. white or #fff or #ffffff
    @Prop(String) readonly copyrightColor!: string;
    // Copyright Location allows configuration for copyright text to display at the bottom of the screen or below the content
      // options:
      //    tight // below content
      //    bottom  // bottom of page
    @Prop(String) readonly copyrightLocation!: string;

    

  @Prop(Array) readonly menuItems!: MenuItem[];

  filterMenuItems() {
    let menuItems: MenuItem[] = [];


    if (this.menuItems) {
      menuItems = this.menuItems.filter((menuItem: MenuItem) => {
        if (typeof menuItem.disabled === 'string') {
          menuItem.disabled = this.$store.getters[menuItem.disabled];

          if (typeof menuItem.disabledTooltip === 'string') {
            menuItem.disabled = this.$store.getters[menuItem.disabledTooltip];
          }
        }

        if (menuItem.routeName === this.$route.name) {
          return false;
        }
        
        if (typeof menuItem.displayCondition === 'string') {
          return this.$store.getters[menuItem.displayCondition] ? this.$store.getters[menuItem.displayCondition] : false;
        } else {
          return true;
        }
      });
    }

    return menuItems;
  }

  getMainClass() {
    switch (this.variant) {
      case 'sidebar-left':
        return 'screen-takeover--left';
      case 'sidebar-right':
        return 'screen-takeover--right';
      default:
        return 'screen-takeover--center';
    }
  }

  getContainerClass() {
    switch (this.variant) {
      case 'sidebar-left':
        return 'screen-takeover__container--sidebar screen-takeover__container--sidebar-left';
      case 'sidebar-right':
        return 'screen-takeover__container--sidebar screen-takeover__container--sidebar-right';
      default:
        return 'screen-takeover__container--center';
    }
  }

  getNavigationClass() {
    switch (this.variant) {
      case 'sidebar-left':
        return 'screen-takeover__menu--left';
      case 'sidebar-right':
        return 'screen-takeover__menu--right';
      default:
        return '';
    }
  }

  redirect(routeName: string) {
    // check if current routeName is the routeName that the menu is going to, ignore if it is
    if (this.$route.name === routeName) {
      return;
    }

    this.$router.push({ name: routeName});
  }
}
